export const BACKLOG_LOAD_START = "BACKLOG_LOAD_START";
export const BACKLOG_LOAD_SUCCESS = "BACKLOG_LOAD_SUCCESS";
export const BACKLOG_LOAD_FAILURE = "BACKLOG_LOAD_FAILURE";

export const BACKLOG_DATA_LOADER_PROGRESS = "BACKLOG_DATA_LOADER_PROGRESS";

export const BACKLOG_EDIT_COMPLETION_DATE_SUCCESS = "BACKLOG_EDIT_COMPLETION_DATE_SUCCESS";
export const BACKLOG_EDIT_COMPLETION_DATE_FAILURE = "BACKLOG_EDIT_COMPLETION_DATE_FAILURE";

export const BACKLOG_EDIT_REMARK_SUCCESS = "BACKLOG_EDIT_REMARK_SUCCESS";
export const BACKLOG_EDIT_REMARK_FAILURE = "BACKLOG_EDIT_REMARK_FAILURE";

export const BACKLOG_GENERAL_EDIT_SUCCESS = "BACKLOG_GENERAL_EDIT_SUCCESS";
export const BACKLOG_GENERAL_EDIT_FAILURE = "BACKLOG_GENERAL_EDIT_FAILURE";

export const BACKLOG_SAMPLE_STATUS_FILTER_START = "BACKLOG_SAMPLE_STATUS_FILTER_START";
export const BACKLOG_SAMPLE_STATUS_FILTER_CHANGE = "BACKLOG_SAMPLE_STATUS_FILTER_CHANGE";
export const BACKLOG_SAMPLE_STATUS_FILTER_COMPLETE = "BACKLOG_SAMPLE_STATUS_FILTER_COMPLETE";

export const BACKLOG_EDIT_APPROVAL_STATUS_SUCCESS = "BACKLOG_EDIT_APPROVAL_STATUS_SUCCESS";
export const BACKLOG_EDIT_APPROVAL_STATUS_FAILURE = "BACKLOG_EDIT_APPROVAL_STATUS_FAILURE";